import { render, staticRenderFns } from "./furniture.vue?vue&type=template&id=6cc41a23&"
import script from "./furniture.vue?vue&type=script&lang=js&"
export * from "./furniture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports